// @flow
import { getUiConsent, submitConsent } from '../../redux/modules/consent';
import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import TermsOfServiceBanner from './TermsOfServiceBanner';

const mapStateToProps = state => {
    const { submitted } = getUiConsent(state);
    return {
        submitted,
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            submitConsent,
        },
        dispatch
    );

type Props = {|
    submitConsent: Function,
    submitted: boolean,
|};

export class TermsOfServiceBannerContainer extends PureComponent<Props> {
    submitConsent = () => {
        this.props.submitConsent(true, 'TermsOfServiceBanner');
    };

    render() {
        const { submitted } = this.props;
        return <TermsOfServiceBanner submitConsent={this.submitConsent} submitted={submitted} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsOfServiceBannerContainer);
